import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './styles.scss';
import { ProtectedRoute } from './utils/protected.route';
import { UserTypeRoute } from './utils/userType.route';

import VersionRoute from './components/shared/VersionRoute';
import HomeV2 from './v2/pages/dashboard/homeV2';
import CreateInspectionV2 from './v2/pages/inspection/createInspectionV2';

import Login from './pages/auth/login';
import NotFound from './pages/error/notFound';
import Home from './pages/dashboard/home';
import ProgressDisplay from './pages/display/progressDisplay';
import ListUsers from './pages/users/users';
import ListProfiles from './pages/users/profiles';
import ListOffice from './pages/users/offices';
import SendAnnouncement from './pages/announcements/sendAnnouncement';
import SendAnnouncementV2 from './v2/pages/announcements/sendAnnouncementV2';
import ListVehicleClasses from './pages/catalog/vehicleClasses';
import ListVehicleType from './pages/catalog/vehicleType';
import ListFuelType from './pages/catalog/fuelType';
import ListService from './pages/config/services';
import EditServices from './pages/config/services.edit';
import ListVehicleService from './pages/catalog/vehicleService';
import ListPieces from './pages/config/pieces';
import ListFluids from './pages/config/fluids';
import ListPaintworks from './pages/config/paintwork';
import ListStates from './pages/config/states';
import ListScores from './pages/config/scores';
import ListPackages from './pages/config/packages';
import CreateInspection from './pages/inspection/createInspection';
import InspectionReport from './pages/inspection/inspectionReport';
import InspectionModifyState from './pages/inspection/inspectionModifyState';
import ListClients from './pages/clients/clients';
import ClientInspectionReport from './pages/clients/inspectionReport';
import InspectionAuthorization from './pages/inspection/inspectionAuthorization';
import ListSchedule from './pages/schedule/schedule';
import ListScheduleTech from './pages/schedule/schedule_tech';
import EditSchedules from './pages/schedule/schedule.edit';
import ListOrders from './pages/orders/orders';
import EditOrders from './pages/orders/orders.edit';
import Validation from './pages/validation/validation';
import ModifiyInspection from './pages/inspection/modifyInspection';
import CriticalPlates from './pages/critical_plates/critical_plates';
import PaymentReport from './pages/payments/paymentReport';
import BiReportInspection from './pages/reportbi/bi_report_inspection';
import ClaimsPlates from './pages/critical_plates/claim_plates';
import ListAccesories from './pages/catalog/accesories';
import UploadFile from './pages/config/uploadFile';
import ShiftManager from './pages/petty_cash/create_shift';
import ShiftMovements from './pages/petty_cash/create_movement';
import ProtectionLaw from './pages/protection_law/principal';
import ImagesReportGallery from './pages/images_report/page';
import FindInspection from './pages/procedures/findInspection';
import ListPqr from './pages/pqr/pqr';
import PqrDetail from './pages/pqr/pqr.detail';

function CustomRoutes() {
  return (
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute
            element={
              <UserTypeRoute
                allowedTypes={['user']}
                element={<VersionRoute v1={<Home />} v2={<HomeV2 />} />}
              />
            }
          />
        }
      />
      <Route path="/display/progress" element={<ProtectedRoute element={<ProgressDisplay />} />} />
      <Route
        path="/users"
        element={<ProtectedRoute element={<ListUsers />} />}
      />
      <Route
        path="/profiles"
        element={<ProtectedRoute element={<ListProfiles />} />}
      />
      <Route
        path="/office"
        element={<ProtectedRoute element={<ListOffice />} />}
      />
      <Route
        path="/sendannouncement"
        element={
          <ProtectedRoute
            element={
              <VersionRoute
                v1={<SendAnnouncement />}
                v2={<SendAnnouncementV2 />}
              />
            }
          />
        }
      />
      <Route
        path="/classesv"
        element={<ProtectedRoute element={<ListVehicleClasses />} />}
      />
      <Route
        path="/typesv"
        element={<ProtectedRoute element={<ListVehicleType />} />}
      />
      <Route
        path="/fueltype"
        element={<ProtectedRoute element={<ListFuelType />} />}
      />

      <Route
        path="/servicesv"
        element={<ProtectedRoute element={<ListVehicleService />} />}
      />
      <Route
        path="/services"
        element={<ProtectedRoute element={<ListService />} />}
      />

      <Route
        path="/accesories"
        element={<ProtectedRoute element={<ListAccesories />} />}
      />

      <Route
        path="/pieces"
        element={<ProtectedRoute element={<ListPieces />} />}
      />

      <Route
        path="/fluids"
        element={<ProtectedRoute element={<ListFluids />} />}
      />

      <Route
        path="/paintwork"
        element={<ProtectedRoute element={<ListPaintworks />} />}
      />

      <Route
        path="/states"
        element={<ProtectedRoute element={<ListStates />} />}
      />

      <Route
        path="/scores"
        element={<ProtectedRoute element={<ListScores />} />}
      />

      <Route
        path="/packages"
        element={<ProtectedRoute element={<ListPackages />} />}
      />

      <Route
        path="/createinspection/"
        element={<ProtectedRoute element={<VersionRoute v1={<CreateInspection />} v2={<CreateInspectionV2 />} />} />}
      />

      <Route
        path="/inspectionreport"
        element={<ProtectedRoute element={<InspectionReport />} />}
      />

      <Route
        path="/inspectionstates"
        element={<ProtectedRoute element={<InspectionModifyState />} />}
      />

      <Route
        path="/modifyInspection/:editid"
        element={<ProtectedRoute element={<VersionRoute v1={<CreateInspection />} v2={<CreateInspectionV2 />} />} />}
      />

      <Route
        path="/clients"
        element={<ProtectedRoute element={<ListClients />} />}
      />

      <Route
        path="/inspectionclientreport"
        element={<ProtectedRoute element={<ClientInspectionReport />} />}
      />

      <Route
        path="/inspectionauth"
        element={<ProtectedRoute element={<InspectionAuthorization />} />}
      />

      <Route
        path="/schedules"
        element={<ProtectedRoute element={<ListSchedule />} />}
      />

      <Route
        path="/myschedule"
        element={<ProtectedRoute element={<ListScheduleTech />} />}
      />

      <Route
        path="/inspectionmodify"
        element={<ProtectedRoute element={<ModifiyInspection />} />}
      />

      <Route
        path="/createcritical"
        element={<ProtectedRoute element={<CriticalPlates />} />}
      />

      <Route
        path="/report_claims"
        element={<ProtectedRoute element={<ClaimsPlates />} />}
      />

      <Route
        path="/payment"
        element={<ProtectedRoute element={<PaymentReport />} />}
      />

      <Route
        path="/uploadfc"
        element={<ProtectedRoute element={<UploadFile />} />}
      />

      <Route
        path="/bireport"
        element={<ProtectedRoute element={<BiReportInspection />} />}
      />

      <Route
        path="/procedures"
        element={<ProtectedRoute element={<FindInspection />} />}
      />

      <Route
        path="/pqr"
        element={<ProtectedRoute element={<ListPqr />} />}
      />

      <Route
        path="/pqr/detail/:id"
        element={<ProtectedRoute element={<PqrDetail />} />}
      />

      {/************ SUBROUTES OF APP **********/}

      <Route
        path="/services/service/:id"
        element={<ProtectedRoute element={<EditServices />} />}
      />

      <Route
        path="/schedules/schedule/:id"
        element={<ProtectedRoute element={<EditSchedules />} />}
      />

      <Route
        path="/orders"
        element={<ProtectedRoute element={<ListOrders canConvert={true} />} />}
      />

      <Route
        path="/ordersclient"
        element={<ProtectedRoute element={<ListOrders canConvert={false} />} />}
      />

      <Route
        path="/orders/order/:id"
        element={<ProtectedRoute element={<EditOrders />} />}
      />

      <Route
        path="/ordersclient/order/:id"
        element={<ProtectedRoute element={<EditOrders />} />}
      />

      <Route
        path="/manager_shift"
        element={<ProtectedRoute element={<ShiftManager />} />}
      />

      <Route
        path="/petty_cash"
        element={<ProtectedRoute element={<ShiftMovements />} />}
      />

      {/************ PUBLIC ROUTES OF APP **********/}

      <Route exact path="/verification/:id" element={<Validation />} />
      <Route
        exact
        path="/images_inspection/:uuid"
        element={<ImagesReportGallery />}
      />
      <Route exact path="/protectionlaw" element={<ProtectionLaw />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default CustomRoutes;
